import { doc, getDoc } from "firebase/firestore";
import React from "react";
import { db } from "../../../firebase";

const GetStudentInTheAttendance = async (students) => {
  const promises = students.map((student) =>
    getDoc(doc(db, "Users", student.id))
  );

  const snapshots = await Promise.all(promises);

  const documents = snapshots.map((snapshot) => {
    return {
      id: snapshot.id,
      FirstName: snapshot.data().FirstName,
      LastName: snapshot.data().LastName,
    };
  });

  return documents;
};

export default GetStudentInTheAttendance;
